import { wordCount } from '__core/shared/util/transform';
import template from './assetFinanceCompliance.template.html';
import templateAddressAddNew from '../address/addNewAddress.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    validationErrors: '<',
    compliance: '<',
    financeProposal: '<',
    ticketClientTypes: '<',
    contacts: '<',
    addresses: '<',
    assets: '<',
    liabilities: '<',
    products: '<',
    lenders: '<',
    income: '<',
    expenses: '<',
    countries: '<',
    feesAndCharges: '<',
    objectives: '<',
    workflow: '<',
    ticketOwner: '<',
    idTicket: '<',
    isDealOwnerBroker: '<',
    isCommercial: '<',
    isTicketSettled: '<',
    onChanged: '&',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $q,
      $rootScope,
      $timeout,
      $mdUtil,
      $mdMedia,
      $mdDialog,
      eventService,
      helperService,
      financeService,
      assetFinanceService,
      AssetFinanceCompliance,
      Address,
      financesService,
      YesNoOption,
      dateTimeService,
      GOOGLEMAPS
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = null;
      ctrl.availableStates = [];
      ctrl.simpleSelectOptions = [];
      ctrl.simpleSelectShortOptions = [];
      ctrl.availableYesNoOptionsOne = [];
      ctrl.availableInterviewMethods = [];
      ctrl.availableIncomeVerificationCompleted = [];
      ctrl.availableBallonPaymentDebtOptions = [];
      ctrl.availableBallonPaymentDebtOptions = [];
      ctrl.applicantsAddresses = [];
      ctrl.interviewAddresses = [];
      ctrl.isMFP = false;
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.googleAutocompleteOptions = {
          componentRestrictions: GOOGLEMAPS.restrictToCountries
        };
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.simpleSelectOptions = helperService.getSimpleSelectOptions();
        ctrl.simpleSelectShortOptions = helperService.getSimpleSelectOptions(true);
        ctrl.availableYesNoOptionsOne = helperService.getAvailableYesNoOptions({ option: 1 });
        ctrl.availableInterviewMethods = helperService.getAvailableInterviewMethods();
        ctrl.availableIncomeVerificationCompleted = helperService.getAvailableIncomeVerificationCompleted();
        ctrl.availableBallonPaymentDebtOptions = assetFinanceService.getAvailableBallonPaymentDebtOptions();
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.compliance = ctrl.compliance || {};
        ctrl.financeProposal = ctrl.financeProposal || {};
        ctrl.ticketClientTypes = ctrl.ticketClientTypes || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.assets = ctrl.assets || [];
        ctrl.liabilities = ctrl.liabilities || [];
        ctrl.products = ctrl.products || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.income = ctrl.income || [];
        ctrl.expenses = _.filter(ctrl.expenses || [], (e) => e?.id && _.isUuid(e?.id));
        ctrl.countries = ctrl.countries || [];
        ctrl.feesAndCharges = ctrl.feesAndCharges || [];
        ctrl.objectives = ctrl.objectives || {};
        ctrl.workflow = ctrl.workflow || {};
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.idTicket = ctrl.idTicket || '';
        ctrl.addressBlank = Address.blank();
        ctrl.isDealOwnerBroker = ctrl.isDealOwnerBroker || false;
        ctrl.isCommercial = ctrl.isCommercial || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        dateTimeService.getSet(
          ctrl,
          ctrl.objectives?.signedDocuments,
          'creditProposalDate',
          'getSetCreditProposalDate'
        );
        ctrl.getAllAddresses();
        if (!ctrl.isTicketSettled) {
          ctrl.isProcessing = true;
          ctrl.financeMonthlyFinancialPositionEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.wordCount = (text) => {
        const s = wordCount(text);
        return s?.length === 1 ? `${s.length} word` : `${s.length || 0} words`;
      };

      ctrl.totalWordCount = () => {
        const allComments = `${
          ctrl.compliance?.comments?.analysisAssessmentAndApplicantEducation || ''
        }
          ${ctrl.compliance?.comments?.optionsPresentedAndRecommendation || ''}
          ${ctrl.compliance?.comments?.abilityToServiceFinancialAnalysis || ''}
          ${ctrl.compliance?.comments?.livingExpenses || ''}
          ${ctrl.compliance?.comments?.general || ''}`;
        return wordCount(allComments);
      };

      ctrl.getAllAddresses = () => {
        ctrl.applicantsAddresses = [];
        for (let a = 0; a < ctrl.compliance?.verifications?.applicants?.length; a += 1) {
          const blankApplicantAddress = !ctrl.compliance?.verifications?.applicants[a]?.address
            ?.street
            ? Address.build(ctrl.compliance.verifications.applicants[a].address)
            : Address.blank();
          const allApplicantAddresses = angular.copy(ctrl.addresses);
          allApplicantAddresses.unshift(blankApplicantAddress);
          ctrl.applicantsAddresses.push(_.compact(allApplicantAddresses));
        }
        const blankInterviewAddress = !ctrl.compliance?.verifications?.interviewDetailsLocation
          ?.street
          ? Address.build(ctrl.compliance.verifications.interviewDetailsLocation)
          : Address.blank();
        const allInterviewAddresses = angular.copy(ctrl.addresses);
        allInterviewAddresses.unshift(blankInterviewAddress);
        ctrl.interviewAddresses = _.compact(allInterviewAddresses);
      };

      ctrl.addNewVerificationsAddress = ($event, idx) => {
        $event.stopPropagation();
        $mdDialog
          .show({
            targetEvent: $event,
            locals: {
              index: idx,
              googleAutocompleteOptions: ctrl.googleAutocompleteOptions,
              availableStates: ctrl.availableStates,
              organizationCountry: ctrl.organizationCountry.name,
              countries: ctrl.countries
            },
            template: templateAddressAddNew,
            controllerAs: '$ctrl',
            controller(
              index,
              googleAutocompleteOptions,
              availableStates,
              organizationCountry,
              countries
            ) {
              const ctr = this;
              ctr.idx = index;
              ctr.googleAutocompleteOptions = googleAutocompleteOptions;
              ctr.availableStates = availableStates;
              ctr.organizationCountry = organizationCountry;
              ctr.countries = countries;
              ctr.address = Address.blank();
              ctr.confirm = () => {
                $mdDialog.hide({ idx: ctr.idx, address: ctr.address });
              };
              ctr.cancel = () => {
                $mdDialog.cancel();
              };
            }
          })
          .then((result) => {
            if (
              result?.address &&
              result?.address?.streetNumber !== '' &&
              result?.address?.street &&
              (result?.address?.suburb || result?.address?.city) &&
              result?.address?.postCode
            ) {
              if (result.idx) {
                ctrl.compliance.verifications.applicants[idx].address = result.address;
              } else {
                ctrl.compliance.verifications.interviewDetailsLocation = result.address;
              }
              ctrl.addresses.push(result.address);
              ctrl.getAllAddresses();
              ctrl.complianceChanges(true);
            }
          });
      };

      ctrl.addressChanged = () => {
        ctrl.getAllAddresses();
        ctrl.complianceChanges(true);
      };

      ctrl.getAddress = (address) =>
        address?.street ? Address.getAddress(address) : 'Select one';

      ctrl.toggleInterviewDetails = (field) => {
        if (
          field === 'interviewDetailsCustomersSpeakAndUnderstandEnglishFluently' &&
          (ctrl.compliance?.verifications
            ?.interviewDetailsCustomersSpeakAndUnderstandEnglishFluently === '' ||
            ctrl.compliance?.verifications
              ?.interviewDetailsCustomersSpeakAndUnderstandEnglishFluently === 1)
        ) {
          ctrl.compliance.verifications.interviewDetailsInterviewWasConductedInTheFollowingLanguage =
            '';
          ctrl.compliance.verifications.interviewDetailsInterviewIsBrokerFluentInThisLanguage =
            '';
          ctrl.compliance.verifications.interviewDetailsInterviewWasTranslatorUsed = '';
        }
        if (
          field === 'interviewDetailsInterviewWasConductedInTheFollowingLanguage' &&
          ctrl.compliance?.verifications
            ?.interviewDetailsInterviewWasConductedInTheFollowingLanguage === ''
        ) {
          ctrl.compliance.verifications.interviewDetailsInterviewIsBrokerFluentInThisLanguage =
            '';
          ctrl.compliance.verifications.interviewDetailsInterviewWasTranslatorUsed = '';
        }
        if (
          field === 'interviewDetailsInterviewIsBrokerFluentInThisLanguage' &&
          (ctrl.compliance?.verifications
            ?.interviewDetailsInterviewIsBrokerFluentInThisLanguage === '' ||
            ctrl.compliance?.verifications
              ?.interviewDetailsInterviewIsBrokerFluentInThisLanguage === 1)
        ) {
          ctrl.compliance.verifications.interviewDetailsInterviewWasTranslatorUsed = '';
        }
        ctrl.complianceChanges(true);
      };

      ctrl.togglePayToSettleDebt = () => {
        if (!ctrl.compliance?.basisForRecommendationsMade?.balloonPayment?.payToSettleDebt) {
          ctrl.compliance.basisForRecommendationsMade.balloonPayment.payToSettleDebtOption = 0;
        }
        ctrl.complianceChanges(true);
      };

      ctrl.toggleDesignDistributionObligations = () => {
        if (
          ctrl.compliance?.basisForRecommendationsMadeAndCustomerDisclosures
            ?.designDistributionObligations?.name === YesNoOption.yes.name
        ) {
          ctrl.compliance.basisForRecommendationsMadeAndCustomerDisclosures.designDistributionObligationsComments =
            '';
        }
        ctrl.complianceChanges(true);
      };

      ctrl.toggleConflictSuitability = (isConflict) => {
        if (
          isConflict &&
          ctrl.compliance?.interestDisclosure?.isConflict?.name === YesNoOption.no.name
        ) {
          ctrl.compliance.interestDisclosure.comments = '';
          ctrl.compliance.interestDisclosure.lenderConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.lenderConflictOfInterestComments = '';
          ctrl.compliance.interestDisclosure.referralConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.referralConflictOfInterestComments = '';
          ctrl.compliance.interestDisclosure.otherConflictOfInterest = false;
          ctrl.compliance.interestDisclosure.otherConflictOfInterestComments = '';
        } else if (!isConflict && !ctrl.compliance.productSuitability.isUnsuitable) {
          ctrl.compliance.productSuitability.isProductInconsistent = false;
          ctrl.compliance.productSuitability.isApplicantComply = false;
        }
        ctrl.complianceChanges(true);
      };

      ctrl.getContact = (idContact) => {
        let contact;
        if (ctrl.contacts.length) {
          contact = ctrl.contacts.find((c) => c.id === idContact);
        }
        return contact;
      };

      ctrl.showCommentsWarning = () =>
        !ctrl.isCommercial &&
        (!ctrl.compliance?.comments?.analysisAssessmentAndApplicantEducation ||
          !ctrl.compliance?.comments?.abilityToServiceFinancialAnalysis ||
          !ctrl.compliance?.comments?.optionsPresentedAndRecommendation ||
          !ctrl.compliance?.comments?.livingExpenses ||
          !ctrl.compliance?.comments?.general);

      ctrl.showBasisWarning = () => {
        if (ctrl.isCommercial) {
          return false;
        }
        const collection = [];
        collection.push(
          !ctrl.compliance?.basisForRecommendationsMade?.financeTerm?.longer &&
            !ctrl.compliance?.basisForRecommendationsMade?.financeTerm?.earlier
        );
        collection.push(!ctrl.compliance?.basisForRecommendationsMade?.paymentFrequency);
        collection.push(
          ctrl.objectives?.signedDocuments?.creditProposal?.name === YesNoOption.none.name
        );
        if (ctrl.objectives?.signedDocuments?.creditProposal?.name === YesNoOption.yes.name) {
          collection.push(!ctrl.objectives?.signedDocuments?.creditProposalDate);
        }
        if (ctrl.objectives?.signedDocuments?.creditProposal?.name === YesNoOption.no.name) {
          collection.push(!ctrl.objectives?.signedDocuments?.creditProposalComments);
        }
        if (ctrl.organizationCountry.cca2 !== 'NZ') {
          collection.push(
            ctrl.compliance?.basisForRecommendationsMadeAndCustomerDisclosures
              ?.designDistributionObligations?.name === YesNoOption.none.name
          );
          if (
            ctrl.compliance?.basisForRecommendationsMadeAndCustomerDisclosures
              ?.designDistributionObligations?.name === YesNoOption.no.name
          ) {
            collection.push(
              !ctrl.compliance?.basisForRecommendationsMadeAndCustomerDisclosures
                ?.designDistributionObligationsComments
            );
          }
        }
        return _.some(collection, (c) => c === true);
      };

      ctrl.noneOfConflictOfInterestDisclosureOptionsSelected = () => {
        const collection = [];
        collection.push(
          ctrl.compliance?.interestDisclosure?.lenderConflictOfInterest &&
            ctrl.compliance?.interestDisclosure?.lenderConflictOfInterestComments !== ''
        );
        collection.push(
          ctrl.compliance?.interestDisclosure?.referralConflictOfInterest &&
            ctrl.compliance?.interestDisclosure?.referralConflictOfInterestComments !== ''
        );
        collection.push(
          ctrl.compliance?.interestDisclosure?.otherConflictOfInterest &&
            ctrl.compliance?.interestDisclosure?.otherConflictOfInterestComments !== ''
        );
        return _.every(collection, (c) => c === false);
      };

      ctrl.showConflictOfInterestDisclosureWarning = () =>
        ctrl.compliance?.interestDisclosure?.isConflict?.name === YesNoOption.none.name ||
        (ctrl.compliance?.interestDisclosure?.isConflict?.name === YesNoOption.yes.name &&
          ctrl.noneOfConflictOfInterestDisclosureOptionsSelected());

      ctrl.showProductSuitabilityWarning = () =>
        ctrl.compliance.productSuitability.isUnsuitable === null ||
        (ctrl.compliance.productSuitability.isUnsuitable &&
          !ctrl.compliance.productSuitability.isProductInconsistent &&
          !ctrl.compliance.productSuitability.isApplicantComply);

      ctrl.getAnnouncement = () =>
        financeService.getMonthlyFinancialPositionAnnouncement({ workflow: ctrl.workflow });

      ctrl.financeMonthlyFinancialPositionEstimate = () => {
        ctrl.isMFP = false;
        financesService
          .monthlyFinancialPosition({ idTicket: ctrl.idTicket || '' })
          .then((res) => {
            if (res?.status && !_.isEmpty(res?.compliance)) {
              ctrl.compliance = AssetFinanceCompliance.Build(res?.compliance);
              const data = {
                compliance: ctrl.compliance
              };
              ctrl.onChanged({ data });
            }
            ctrl.isProcessing = false;
          });
      };

      ctrl.complianceChanges = _.debounce((isSilent) => {
        if (!isSilent) {
          ctrl.isMFP = true;
        }
        ctrl.saveAssetFinanceCompliance();
      }, 3000);

      ctrl.toggleSignedDocuments = () => {
        ctrl.objectives.signedDocuments.creditProposalDate = 0;
        ctrl.objectives.signedDocuments.creditProposalComments = '';
        // eslint-disable-next-line no-underscore-dangle
        ctrl.__getSetCreditProposalDate = '';
        ctrl.saveAssetFinanceCompliance();
      };

      ctrl.saveAssetFinanceCompliance = () => {
        if (!ctrl.isCommercial) {
          ctrl.compliance.monthlyFinancialPosition.totalWords = ctrl.totalWordCount();
        }
        ctrl.isProcessing = ctrl.isMFP;
        const data = {
          compliance: ctrl.compliance,
          objectives: ctrl.objectives,
          aFCD: ctrl.isMFP ? 'assetFinanceCompliance' : ''
        };
        ctrl.onFinished({ data });
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'assetFinanceCompliance') {
          ctrl.financeMonthlyFinancialPositionEstimate();
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
